import { CosmosConn } from '../../../core/cosmos/api';

import styles from './feedBack.module.scss';

import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbDown from '@mui/icons-material/ThumbDownAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbUp from '@mui/icons-material/ThumbUpAlt';

import { Box, Button, Modal } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import { ChatUserContext } from '../../../core/chatContext';


const FeedbackComponent: React.FC<{ userId: string, conversationId: string, idx: any, }> = ({ userId, conversationId, idx }) => {
    const currChatContext: any = useContext(ChatUserContext);

    const maxWidth = useMediaQuery('(max-width:480px)');
    const maxHeight = useMediaQuery('(max-height:376px)');

    const [comment, setComment] = useState<string>('');
    const [open, setOpen] = useState<boolean>(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const modalContainer = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: maxHeight || maxWidth ? 250 : 400,
        bgcolor: 'white',
        borderRadius: 4,
        boxShadow: 24,
        p: 3,
        opacity: 1,
        display: 'flex',
        flexDirection: 'column',
    }


    const evaluationResponse = async (action: string, messageId: string) => {
        const Cosmos_Connection = new CosmosConn();

        await Cosmos_Connection.evaluationConversation(userId, conversationId, messageId, action, comment)
            .then((response) => {
                if (response) {

                    currChatContext.currHistory.map((history: any) => {
                        if (history.id === conversationId) {
                            const messagesSelected = history.messages.map((message: any) => {
                                if (message.id === messageId) {
                                    message.evaluation = action;
                                    message.comment = comment;
                                }
                                return message;
                            })

                            const select = messagesSelected.filter((message: any) => message.role === 'assistant')

                            currChatContext.setIaAnswers(select);

                            currChatContext.setCurrChat((prevCurrChat: any) => ({
                                ...prevCurrChat,
                                messages: messagesSelected
                            }));
                        }
                        return history;
                    })

                    toast.success("Mensaje correctamente evaluado", {
                        duration: 1000,
                        style: {
                            border: '1px black',
                            background: '#fff',
                            color: 'black',
                            padding: '20px'
                        }
                    }
                    )
                } else {
                    toast.error("Error al evaluar el mensaje", {
                        duration: 8000,
                        style: {
                            border: '1px black',
                            background: '#CD5C5C',
                            color: 'white',
                            padding: '20px'
                        }
                    })
                }
            })
        
    }

    const something = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === 'Enter') {
            evaluationResponse('down', idx.id);
            handleClose();
        }
        if (event.key === 'Escape') {
            setComment('');
            handleClose();
        }
    }

    let content;

    // if (idx?.id === "0") {
    //     // es el cargando respuesta...
    //     // no devolvemos nada
    // }

    if (!idx?.evaluation || idx?.evaluation === '') {
        content = (
            <>
                <span className={styles.dialogFeedback__thumbdown} onClick={() => {
                    if (!currChatContext.isLoading) {
                        evaluationResponse('up', idx?.id);
                    }else { toast.error("Espere a que la respuesta sea generada", { duration: 2000 }); }

                }}>
                    <ThumbUpOffAltIcon />
                </span>
                <span className={styles.dialogFeedback__thumbup} onClick={(e) => {
                    if (!currChatContext.isLoading) {
                        handleOpen();
                    } else { toast.error("Espere a que la respuesta sea generada", { duration: 2000 }); }
                }}>
                    <ThumbDownOffAltIcon />
                </span>
            </>
        );
    } else if (idx?.evaluation === "up") {
        content = (
            <span className={styles.dialogFeedback__thumbup}>
                <ThumbUp style={{ color: '#666666', cursor: "auto" }} />
            </span>
        );
    } else if (idx?.evaluation === "down") {
        content = (
            <span className={styles.dialogFeedback__thumbdown}>
                <ThumbDown style={{ color: '#666666', cursor: "auto" }} />
            </span>
        );
    }

    return (
        <div className={styles.dialogFeedback}>
            {
                content
            }
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalContainer}>
                    <h4 style={{ marginTop: '0px' }}>Feedback</h4>
                    <span className={styles.modalContainerTitle}>{idx?.content ? idx?.content : 'Respuesta del servicio de IA...'}</span>


                    <textarea onKeyDown={(e: any) => something(e)} autoFocus className={styles.textArea} onChange={
                        (event: any) => setComment(event.target.value)
                    }></textarea>


                    <div className={styles.modalContainerButtons}>
                        <Button sx={{ '&:hover': { backgroundColor: "#003cff", color: "#e1f1ff" }, width: "100px", color: "#2e2e2e" }} onClick={() => {
                            if (comment.length === 0) {
                                toast.error("Debe introducir un texto para el comentario.", {
                                    duration: 1000,
                                    style: {
                                        border: '1px black',
                                        background: '#CD5C5C',
                                        color: 'white',
                                        padding: '10px',
                                        maxWidth: 400
                                    }
                                })
                                return
                            }
                            evaluationResponse('down', idx.id);
                            handleClose();
                        }}>Enviar</Button>
                        <Button sx={{ '&:hover': { backgroundColor: "#003cff", color: "#e1f1ff" }, width: "100px", color: "#2e2e2e" }}
                            onClick={() => {
                                handleClose();
                                setComment('');
                            }}>Cancelar</Button>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}

export { FeedbackComponent }

